module.exports = __webpack_public_path__ + "static/media/shopping-cart-pink.30aba820.svg";